/**
 * Created by anatoly on 14.11.2024
 */

const LockedCalendarTileComponent = cc.Node.extend({
    ctor: function (tile) {
        this._super();

        this.tile = tile;
        this.createMarks();
    },

    isLast: function () {
        return this.tile.isLast;
    },

    createMarks: function () {
        if (!bundles.prizecalendar.jsons.padlock_json) {
            return;
        }

        const styles = cleverapps.styles.PrizeCalendarTileView;

        this.mark = new cleverapps.Spine(bundles.prizecalendar.jsons.padlock_json);
        this.mark.setAnimation(0, "idle", true);
        this.mark.setAlignment(styles.mark);
        this.addChild(this.mark);
    },

    openTile: function (callback) {
        if (this.mark) {
            this.mark.setAnimation(0, "hide", false);
        }

        const actions = [
            function (f) {
                this.showUpReward(f);
            }.bind(this),

            function (f) {
                const bgChangeAnimations = this.getBgChangeAndIdleAnimations();

                if (bgChangeAnimations) {
                    this.changeBgAnimation(bgChangeAnimations, f);
                    return;
                }
                f();
            }.bind(this)
        ];

        new ActionPlayer(actions).play(callback);
    },

    showUpReward: function (callback) {
        if (!["heroes", "wooden"].includes(cleverapps.config.ui) || this.isLast()) {
            callback();
            return;
        }

        const scene = cleverapps.Scenes.GetRunningScene();

        const tileView = this.getParent();

        const bg = tileView.innerBg || tileView.outerBg;

        bg.replaceParentSamePlace(scene);
        bg.setLocalZOrder(scene.movingNode.getLocalZOrder() + 1);

        const rewardIcon = this.tile.rewardsList.rewards[0].getIcon();

        rewardIcon.setPosition(this.width / 2, this.height / 2 + 200);
        this.addChild(rewardIcon);

        rewardIcon.replaceParentSamePlace(scene);
        rewardIcon.setLocalZOrder(bg.getLocalZOrder() - 1);

        rewardIcon.setVisible(false);
        rewardIcon.runAction(new cc.Sequence(
            StandartAnimations.showUp(rewardIcon, { flash: true }),
            new cc.MoveBy(0.3, 0, -225),
            new cc.RemoveSelf(),
            new cc.CallFunc(() => {
                bg.replaceParentSamePlace(tileView);
                bg.setLocalZOrder(0);
            })
        ));

        if (cleverapps.config.ui === "wooden") {
            bg.setAnimation(0, "w_box_drop_prize");
            bg.setCompleteListener(callback);

            return;
        }

        callback();
    },

    getBgChangeAndIdleAnimations: function () {
        if (["heroes", "wooden"].indexOf(cleverapps.config.ui) === -1) {
            return;
        }

        return {
            animations: this.isLast() ? {
                animation: cleverapps.config.ui === "heroes" ? "active_idle_last" : "to_active_last",
                idle: "active_idle_last"
            } : {
                animation: "to_active",
                idle: "active_idle"
            },
            bg: cleverapps.config.ui === "heroes" ? this.getParent().outerBg : this.getParent().innerBg
        };
    },

    changeBgAnimation: function (bgChangeAnimations, callback) {
        const animations = bgChangeAnimations.animations;
        const bg = bgChangeAnimations.bg;

        bg.setAnimationAndIdleAfter(animations.animation, animations.idle);
        bg.setCompleteListener(callback);
    }
});